import { render, staticRenderFns } from "./ModalManageMenu.vue?vue&type=template&id=79407912&"
import script from "./ModalManageMenu.vue?vue&type=script&lang=js&"
export * from "./ModalManageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports